import { render, staticRenderFns } from "./InstitutionProviderProductsView.vue?vue&type=template&id=0e0f1ad8"
import script from "./InstitutionProviderProductsView.vue?vue&type=script&lang=js"
export * from "./InstitutionProviderProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports